import { gql } from '@apollo/client';
const COUPON_FIELDS = `
      id
      code
      effective_from
      effective_to
      reward_ids
      applicable_product_codes
      purpose_ids
      message
      update_date
      create_date
`;
export const PROMOTION_VALIDATION = gql`
  mutation PromotionValidate($product_id: PRODUCT_ID, $promo_code: PROMO_CODE) {
    promotionValidate(product_id: $product_id, promo_code: $promo_code)
      @rest(type: "Promotion", path: "/promotion/validate?{args}") {
      __typename
      promo_code
      message
      banner_name
      banner_message
      effective_to
      display_effective_to
      allow_save
    }
  }
`;
export const RETRIEVE_REFERRAL = gql`
  query Referral($id: ID!) {
    referral(id: $id) @rest(type: "Referral", path: "/referral/{args.id}") {
      __typename
      id
      campaign_code
      referrer_reward_redemptions
      status
      create_date
      update_date
    }
  }
`;
export const LIST_REFERRAL = gql`
  query Referrals($reward_type: String) {
    referrals(reward_type: $reward_type)
      @rest(type: "[Referral]", path: "/referral?{args}") {
      __typename
      id
      campaign_code
      referrer_reward_redemptions
      status
      create_date
      update_date
    }
  }
`;
export const LIST_REFERRAL_COUPON = gql`
  query ReferralCoupons($campaign_code: String) {
    referralCoupons(campaign_code: $campaign_code)
      @rest(type: "[ReferralCoupon]", path: "/referral-coupon?{args}") {
      __typename
      id
      campaign_code
      coupon
    }
  }
`;
export const GET_OR_CREATE_REFERRAL_COUPON = gql`
  mutation CreateReferralCoupon {
    createReferralCoupon(input: $input)
      @rest(
        type: "ReferralCoupon"
        path: "/referral-coupon/get-or-create"
        method: "POST"
      ) {
      __typename
      id
      campaign_code
      coupon
    }
  }
`;
export const RETRIEVE_REFERRAL_REWARD_SUM = gql`
  query ReferralRewardSum {
    referralRewardSum
      @rest(
        type: "ReferralRewardSum"
        path: "/referral/accumulated-bowtie-cash"
      ) {
      __typename
      accumulated_bowtie_cash
    }
  }
`;
export const RETRIEVE_REFERRAL_SUMMARY = gql`
  query ReferralSummary($id: ID) {
    summary(id: $id)
      @rest(
        type: "ReferralSummary"
        path: "/referral-campaign/{args.id}/summary"
      ) {
      __typename
      eligible
      referral_count
      total_referral_count
      aggregated_rewards
      rewarded_policy_numbers
      last_referral_date
    }
  }
`;
export const RETRIEVE_COUPON = gql`
  query Coupon($code: String!) {
    coupon(code: $code) @rest(type: "Coupon", path: "/coupon/{args.code}") {
      __typename
      ${COUPON_FIELDS}
    }
  }
`;
export const LIST_COUPON = gql`
  query Coupons($code: String) {
    coupons(code: $code) @rest(type: "[Coupon]", path: "/coupon?{args}") {
      __typename
      ${COUPON_FIELDS}
    }
  }
`;
export const CREATE_COUPON_OFFER = gql`
  mutation CreateCouponOffer {
    createCouponOffer(input: $input)
      @rest(type: "CouponOffer", path: "/coupon-offer", method: "POST") {
      __typename
    }
  }
`;
export const LIST_REWARD_SET = gql`
  query RewardSets($coupon_code: String) {
    rewardSets(coupon_code: $coupon_code)
      @rest(type: "[RewardSet]", path: "/reward-set?{args}") {
      __typename
      id
      effective_from
      effective_to
      display_effective_to
      rewards
      applicable_product_codes
      message
      update_date
      create_date
    }
  }
`;
export const RETRIEVE_PROMOTION_CAMPAIGN = gql`
  query PromotionCampaign($id: ID!) {
    promotionCampaign(id: $id)
      @rest(type: "PromotionCampaign", path: "/promotion-campaign/{args.id}") {
      __typename
      id
      code
      name
      start_date
      end_date
      description
      purpose
      create_date
      update_date
      remarks
    }
  }
`;
export const VERIFY_PROMOTION_CAMPAIGN = gql`
  mutation PromotionCampaignVerification($id: ID!) {
    promotionCampaignVerification(id: $id, input: {})
      @rest(
        type: "PromotionCampaignVerification"
        path: "/promotion-campaign/{args.id}/verify"
        method: "POST"
      ) {
      __typename
      promotion_campaign
      redeem_date
    }
  }
`;
export const REDEEM_PROMOTION_CAMPAIGN = gql`
  mutation RedeemPromotionCampaign($id: ID!) {
    redeemPromotionCampaign(id: $id, input: {})
      @rest(
        type: "PromotionCampaign"
        path: "/promotion-campaign/{args.id}/redeem"
        method: "POST"
      ) {
      __typename
    }
  }
`;
export const RETRIEVE_CROSS_SELL_SUMMARY = gql`
  query CrossSellSummary {
    crossSellSummary
      @rest(
        type: "CrossSellSummary"
        path: "/cross-sell-promotion-campaign/summary"
      ) {
      __typename
      id
      code
      name
      start_date
      end_date
      description
      purpose
      create_date
      update_date
      remarks
    }
  }
`;
export const RETRIEVE_BEST_OFFER = gql`
  query BestOffer(
    $product_code: String
    $public_coupon_types: String
    $existing_customer_coupon_types: String
  ) {
    bestOffer(
      product_code: $product_code
      public_coupon_types: $public_coupon_types
      existing_customer_coupon_types: $existing_customer_coupon_types
    ) @rest(type: "BestOffer", path: "/best-offer?{args}") {
      __typename
      code
      reason
    }
  }
`;
export const LIST_USABLE_COUPON = gql`
  query UsableCoupons($product_codes: String) {
    usableCoupons(product_codes: $product_codes)
      @rest(type: "UsableCoupon", path: "/usable-coupon?{args}") {
      __typename
      code
      reason
      type
      message
      banner_name
      banner_message
      effective_to
      display_effective_to
      is_saved
      saved_effective_to
      allow_save
    }
  }
`;
export const SAVE_COUPON = gql`
  mutation SaveCoupon {
    saveCoupon(input: $input)
      @rest(
        type: "[Coupon]"
        path: "/coupon/save-coupon"
        method: "POST"
        bodyKey: "input"
      ) {
      __typename
      ${COUPON_FIELDS}
    }
  }
`;
export const LIST_SAVED_COUPONS = gql`
  query ListSavedCoupons($applicable_product_code: String) {
    savedCoupons(applicable_product_code: $applicable_product_code)
      @rest(type: "[Coupon]", path: "/coupon/saved-coupon?{args}") {
      __typename
      ${COUPON_FIELDS}
    }
  }
`;